import moment from "moment-timezone";
import {
	approveUSDT, getNFTInfo,
	nftEthCall, sendErc20Trans,
	sendInteractorTrans,
	usdtEthCall
} from "@/utils/web3Helper";
import {hideLoading, showLoading} from "@/utils/spinnerHelper";
import {Interactor, isProd} from "@/utils/constants";
import {formatUnits} from "ethers";
import {showToast} from "@/utils/toastHelper";
import {postRequestAsync} from "@/utils/request";
import {v4} from "uuid";
import {getLanguageStore} from "@/lang/langStore"

function getFormatedCountdownTime(seconds) {
	const hours = Math.floor(seconds / 3600);
	const mins = Math.floor((seconds % 3600) / 60);
	const second = seconds % 60;

	if (hours === 0 && mins === 0) {
		return `${second}${getLanguageStore().localize('秒')}`;
	}

	if (hours === 0) {
		return `${mins}${getLanguageStore().localize('分')}${second}${getLanguageStore().localize('秒')}`;
	}

	return `${hours}${getLanguageStore().localize('时')}${mins}${getLanguageStore().localize('分')}${second}${getLanguageStore().localize('秒')}`;
}

function truncateDecimals(num, decimals) {
	const factor = Math.pow(10, decimals);
	return Math.floor(num * factor) / factor;
}

function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

function getNftStateCode (item, resonancePeriod, nftExpireTime, nftResonanceRewardExpireTime) {
	const currentTimestamp = parseInt(moment().format('X'))
	if (item.startResonanceTime === 0) {
		return 0 //共振未开始
	}
	if (item.startResonanceTime > 0 && currentTimestamp - item.startResonanceTime < resonancePeriod) {
		return 1 //共振中
	}
	if (item.startResonanceTime > 0 && currentTimestamp - item.startResonanceTime > resonancePeriod && item.resonanceDepositWithdrawTimestamp === 0) {
		return 2 //共振到期 可以提取共振奖金
	}
	if (item.startResonanceTime > 0 && item.resonanceDepositWithdrawTimestamp > 0 && currentTimestamp - item.resonanceDepositWithdrawTimestamp < nftResonanceRewardExpireTime) {
		if(item.energyRemain < 1) {
			return -2
		}
		return 3 //共振金已经提取，共振奖励未过期，可以开始下一轮共振
	}
	if (item.startResonanceTime > 0 && item.resonanceDepositWithdrawTimestamp > 0 && currentTimestamp - item.resonanceDepositWithdrawTimestamp > nftResonanceRewardExpireTime && currentTimestamp - item.resonanceDepositWithdrawTimestamp < nftExpireTime) {
		if(item.energyRemain < 1) {
			return -2
		}
		return 4 //共振金已经提取，共振奖励已过期，NFT未失效，可以开始下一轮共振
	}
	if (item.startResonanceTime > 0 && item.resonanceDepositWithdrawTimestamp > 0 && currentTimestamp - item.resonanceDepositWithdrawTimestamp > nftExpireTime) {
		return -1 //共振金已经提取，NFT已经失效
	}

}

async function withdrawResonanceDeposit(nft, wallet) {
	if (!nft || !wallet) return
	const loadingId = v4()
	const ls = getLanguageStore()
	showLoading(ls.localize('操作中'), loadingId)
	try {
		console.log(`tokenId: ${nft?.tokenId}`)
		const triggerAmount = await nftEthCall('resonanceRefundDepositTriggerAmount', [nft?.nftType])
		console.log(`triggerAmount: ${triggerAmount}`)
		const allowance = await usdtEthCall('allowance', [wallet, Interactor])
		console.log(`allowance: ${allowance}`)
		console.log(`triggerAmount: ${triggerAmount}`)
		if (BigInt(allowance) < BigInt(triggerAmount)) {
			const {success} = await sendErc20Trans('approve', [Interactor, BigInt(triggerAmount)])
			if (success !== true) {
				showToast(ls.localize('授权失败'))
				hideLoading(loadingId)
				return
			}
			await sleep(3000)
			showToast(ls.localize('授权成功'))
		}
		const sigResult = await postRequestAsync('sig/getResonanceSig',
			{wallet: wallet, tokenId: nft?.tokenId})

		if (sigResult?.code !== 200 || sigResult?.msg?.nonce === null || !sigResult?.msg?.timestamp || !sigResult?.msg?.deadline || !sigResult?.msg?.signature) {
			showToast(ls.localize('获取数据失败'))
			hideLoading(loadingId)
			return
		}
		const {success} = await sendInteractorTrans('endNftResonance', [nft?.tokenId, sigResult?.msg?.nonce, sigResult?.msg?.timestamp, sigResult?.msg?.deadline, sigResult?.msg?.signature])
		// const {success} = await withdrawResonanceDeposit(nft?.tokenId, sigResult?.msg?.nonce, sigResult?.msg?.timestamp, sigResult?.msg?.deadline, sigResult?.msg?.signature)
		if (success === true) {
			await sleep(3000)
			showToast(ls.localize('操作成功'))
		} else {
			showToast(ls.localize('操作失败'))
		}
	} finally {
		hideLoading(loadingId)
	}
}

async function getToFixed () {
	return isProd === true ? 1 : 6
}

async function startResonance() {

}

async function getTokenRemainEnergy (tokenId) {
	if (!tokenId){
		return 0
	}

	const tokenInfo = await getNFTInfo(tokenId)
	const energy = Number(tokenInfo['3']) / Math.pow(10, 18)
	console.log(`energy: ${energy}`)
	const energyUsed = Number(tokenInfo['4']) / Math.pow(10, 18)
	console.log(`energyUsed: ${energyUsed}`)

	return energy - energyUsed
}

export {
	getFormatedCountdownTime,
	truncateDecimals,
	sleep,
	getNftStateCode,
	withdrawResonanceDeposit,
	startResonance,
	getToFixed,
	getTokenRemainEnergy
}